const INV_SAVING = 'INV_SAVING'
const INV_SAVING_SUCCESS = 'INV_SAVING_SUCCESS'
const INV_SAVING_ERROR = 'INV_SAVING_ERROR'
const INV_FETCHING_INVITATION = 'INV_FETCHING_INVITATION'
const INV_FETCHING_INVITATION_SUCCESS = 'INV_FETCHING_INVITATION_SUCCESS'
const INV_FETCHING_INVITATION_ERROR = 'INV_FETCHING_INVITATION_ERROR'
const INV_FETCHING_IS_STUDENT = 'INV_FETCHING_IS_STUDENT'
const INV_FETCHING_IS_STUDENT_SUCCESS = 'INV_FETCHING_IS_STUDENT_SUCCESS'
const INV_FETCHING_IS_STUDENT_ERROR = 'INV_FETCHING_IS_STUDENT_ERROR'

 export function fetchingIsStudent() {
  return {
    type: INV_FETCHING_IS_STUDENT,
  }
}

export function fetchingIsStudentSuccess(isStudent) {
  return {
    type: INV_FETCHING_IS_STUDENT_SUCCESS,
    isStudent,
  }
}

export function fetchingIsStudentError(error) {
  return {
    type: INV_FETCHING_IS_STUDENT_ERROR,
    error,
  }
}

export function fetchingInvitation() {
  return {
    type: INV_FETCHING_INVITATION,
  }
}

export function fetchingInvitationSuccess(invitation) {
  return {
    type: INV_FETCHING_INVITATION_SUCCESS,
    invitation,
  }
}

export function fetchingInvitationError(error) {
  return {
    type: INV_FETCHING_INVITATION_ERROR,
    error,
  }
}

export function saving () {
  return {
    type: INV_SAVING
  }
}

export function savingSuccess () {
  return {
    type: INV_SAVING_SUCCESS,
  }
}

export function savingError (error) {
  return {
    type: INV_SAVING_ERROR,
    error,
  }
}

const initialState = {
  isSaving: false,
  isSavingError: '',
  isFetchingInvitation: false,
  isFetchingInvitationError: '',
  invitation: null,
  isStudent: false,
  isFetchingIsStudent: false,
  isFetchingIsStudentError: false,
  isFetchingIsStudentErrorContent: '',
}

export function invites (state = initialState, action) {
  switch (action.type) {
    case INV_FETCHING_IS_STUDENT :
      return {
        ...state,
        isFetchingIsStudent: true,
      }
    case INV_FETCHING_IS_STUDENT_SUCCESS :
      return {
        ...state,
        isFetchingIsStudent: false,
        isStudent: action.isStudent
      }
    case INV_FETCHING_IS_STUDENT_ERROR :
      return {
        ...state,
        isFetchingIsStudent: false,
        isFetchingIsStudentErrorContent: action.error,
        isFetchingIsStudentError: true,
      } 
    case INV_SAVING_SUCCESS : 
      return {
        ...state,
        isSaving: false,
      }
    case INV_SAVING_ERROR :
      return {
        ...state,
        isSaving: false,
        isSavingError: action.error,
      }
    case INV_FETCHING_INVITATION :
      return {
        ...state,
        isFetchingInvitation: true,
      }
    case INV_FETCHING_INVITATION_SUCCESS :
    return {
        ...state,
        isFetchingInvitation: false,
        invitation: action.invitation,
      }
    case INV_FETCHING_INVITATION_ERROR :
      return {
        ...state,
        isFetchingInvitation: false,
        isFetchingInvitationError: action.error,
      }
    case INV_SAVING :
      return {
        ...state,
        isSaving: 'true'
      }
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/invites.js